document.addEventListener("DOMContentLoaded", function() {
  var popup = document.getElementById("popup");

  // Vérifie si le popup existe (car désactivé côté Liquid, il ne sera pas rendu)
  if (!popup) {
    // Si la section est désactivée dans les settings → on vide l'historique
    localStorage.removeItem("popupShown");
    return;
  }

  // Si la section est activée et jamais vue → on affiche
  if (!localStorage.getItem("popupShown")) {
    popup.style.display = "flex";
  }

  // Gestion du bouton de fermeture
  var closeBtn = document.getElementById("closePopup");
  if (closeBtn) {
    closeBtn.addEventListener("click", function() {
      popup.style.display = "none";
      localStorage.setItem("popupShown", "true");
    });
  }
});
